module.exports = __webpack_public_path__ + "static/img/yshh1-2.9378d18.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/layout/yshh1-2.png
// module id = 775
// module chunks = 0